import isEmpty from 'ramda/es/isEmpty'
import clone from 'ramda/es/clone'
import AbstractPiniaModel from '../../models/AbstractPiniaModel'
import { useBlockStore } from '../../pinia/stores/block'
import { blockAlreadyVisited } from '../IntroTypes/BlockIntro/model/blockintro'


const log = AbstractPiniaModel.log
export class Block extends AbstractPiniaModel {
    //#region Instance Code
        constructor(block) { super(block) }

        id()                    { return Number(this.source.id) }
        blockNumber()           { return Number(this.source.block) }
        name(idx=-1)            {
            if(idx===-1)
                idx = this.blockNumber() + 1
            return super.getByAliases(['name'], 'Block '+idx)
        }
        introTextTop()          { return this.source.text_einleitung_oben }
        textConstantTop()       { return this.source.text_konstant_oben }
        introTextBottom()       { return this.source.text_einleitung_unten }
        textConstantBottom()    { return this.source.text_konstant_unten }
        textToMemorize()        { return this.source.merktext }
        timeToMemorize()        { return Number(this.source.merkzeit) }

        textTopAreaStyles()     { return this.getByAliases(['text_oben_css'], '') }
        textConstTopAreaStyles(){ return this.getByAliases(['text_konstant_oben_css'], '') }

        hasTextToMemorize()     { return !isEmpty(this.textToMemorize()) }
    //#endregion Instance Code

    //#region Static Methods

        static piniaStore()     { return useBlockStore() }

        static create(source)   { return new Block(source) }

        static getSelected()    { return Block.create(this.piniaStore().selectedBlock) }

        static select(block)    { this.piniaStore().selectBlock(clone(block.getSource())) }

        static reset()          { this.piniaStore().resetBlocks() }

        static alreadyVisited(info)    { 
           return blockAlreadyVisited(info) 
        }
    //#region Static Methods

}
